import { IEnvironment } from './env.interface';
import RUNTIME_CONFIG from '~environments/env.runtime';

export const ENV_CONFIG: IEnvironment = RUNTIME_CONFIG;

/*
// Explicit environment variable export
*/
export const BRAND = ENV_CONFIG.BRAND;
export const TEALIUM = ENV_CONFIG.TEALIUM;
export const CHANNEL = ENV_CONFIG.CHANNEL;
export const LANGUAGE = ENV_CONFIG.LANGUAGE;
export const APIGEE_APP_KEY = ENV_CONFIG.APIGEE_APP_KEY;
export const LAUNCH_DARKLY_ENV_KEY = ENV_CONFIG.LAUNCH_DARKLY_ENV_KEY;
export const LAUNCH_DARKLY_SDK_KEY = ENV_CONFIG.LAUNCH_DARKLY_SDK_KEY;
export const ESL_APP_KEY = ENV_CONFIG.ESL_APP_KEY;
export const API_PATH = ENV_CONFIG.API_PATH;
export const AEM_PATH = ENV_CONFIG.AEM_PATH;
export const APIGEE_MICROSERVICE_PORT = ENV_CONFIG.APIGEE_MICROSERVICE_PORT;
export const WHITE_LIST_DOMAINS = ENV_CONFIG.WHITE_LIST_DOMAINS;
export const ENDPOINTS = ENV_CONFIG.ENDPOINTS;
export const environment = ENV_CONFIG.environment;
export const ADRUM = ENV_CONFIG.ADRUM;
export const APIGEE_APP_KEY_GQL = ENV_CONFIG.APIGEE_APP_KEY_GQL;
export const ADVERTISEMENT = ENV_CONFIG.ADVERTISEMENT;
export const LOADER = ENV_CONFIG.LOADER;
export const FORGEROCK_CONFIG = ENV_CONFIG.FORGEROCK_CONFIG;
export const APIGEE_APP_KEY_MESSAGE_CENTER =
  ENV_CONFIG.APIGEE_APP_KEY_MESSAGE_CENTER;
export const PAYMENT_APP_KEY = ENV_CONFIG.PAYMENT.APP_KEY;
export const BEACON_API = ENV_CONFIG.BEACON_API;
